<template>
  <div class="star-picker">
    <button
      v-for="s in 5"
      :key="s"
      type="button"
      class="sp-btn"
      :class="{
        'sp-btn--on':    s <= (hoverStar || modelValue),
        'sp-btn--hover': s <= hoverStar,
      }"
      @mouseenter="hoverStar = s"
      @mouseleave="hoverStar = 0"
      @click="$emit('update:modelValue', s)"
      :aria-label="'تقييم ' + s + ' نجوم'"
    >★</button>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({ modelValue: { type: Number, default: 0 } });
defineEmits(['update:modelValue']);

const hoverStar = ref(0);
</script>

<style scoped>
.star-picker { display: flex; gap: .25rem; }
.sp-btn {
  background: none; border: none; cursor: pointer;
  font-size: 2rem; color: #E5E7EB;
  transition: color .15s, transform .15s;
  padding: .1rem; line-height: 1;
}
.sp-btn--on { color: #F59E0B; }
.sp-btn--hover, .sp-btn:hover { color: #FBBF24 !important; transform: scale(1.18); }
</style>
